﻿/** Ensure that the property name exists on an object */
export const nameof = <T>(name: keyof T & string): string => name;
